import { Card, Col, Avatar, Row, message, Spin, Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "./dashboard.scss";
import profile from "../../assets/profile.png";
import menuicon from "../../assets/SlidersHorizontal.png";
import { formatToLocalTime } from "../functions";
import dashboardService from "../../services/dashboardService";
import InfiniteScroll from "react-infinite-scroll-component";
import circle from "../../assets/circle-update.svg";
import active from "../../assets/circle-active.svg";
import { ThemeContext } from "../../context/themeProvider";

const ROOT = `dashboard_module`;

export default function TransactionTableReferral(props) {
  const { cardBackgroundColor } = props;
  // const [totalAffiliates, setTotalAffiliates] = useState('')
  const [affiliateUsers, setAffiliateUsers] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [scrollPage, setScrollPage] = useState(1);
  const pageLimit = 10;
  const { setLoading } = useContext(ThemeContext);

  useEffect(() => {
    getDetailsFunc(1);
  }, [sortOrder]);

  const getDetailsFunc = async (page) => {
    let dataToSend = {
      ascending: sortOrder,
      currentPage: page,
    };
    try {
      setLoading(true);
      const response = await dashboardService.getUserAffiliates(dataToSend);
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message ||
            "Something went worng in getting user details"
        );
      } else {
        // console.log(response?.data)
        let totalUsers = response?.data[0]?.metadata[0]?.total;
        let users = response?.data[0]?.data;
        if (page !== 1) {
          setAffiliateUsers(affiliateUsers.concat(users || []));
        } else {
          setAffiliateUsers(users || []);
        }
        if (page * pageLimit >= totalUsers) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
        // setTotalAffiliates(totalUsers)
        setScrollPage(page + 1);
      }
    } catch (error) {
      message.destroy();
      message.error(error.response?.data?.message);
    }
    setLoading(false);
  };

  return (
    <>
      <Card
        style={{ backgroundColor: `${cardBackgroundColor}` }}
        className={`${ROOT}__tran_ui`}
        title="Referral History"
        extra={
          <>
            <div className="menu_filter">
              <select onChange={(e) => setSortOrder(e.target.value)}>
                {/* <option value=""></option> */}
                <option value="false">Newest First</option>
                <option value="true">Oldest First</option>
              </select>
              <span>
                {" "}
                <img size={16} src={menuicon} alt="" />
              </span>
            </div>
          </>
        }
      >
        <Row>
          <Col lg={24} xs={24} md={24} sm={24}>
            <div
              style={{ height: "auto", overflow: "auto", padding: 10 }}
              id="scroll-target"
            >
              <InfiniteScroll
                // style={{ overflow: "hidden" }}
                dataLength={affiliateUsers.length}
                next={() => getDetailsFunc(scrollPage)}
                hasMore={hasMore}
                loader={
                  affiliateUsers.length > 0 && (
                    <div style={{ zIndex: 9999, textAlign: "center" }}>
                      <Spin />
                      <p>Loading...</p>
                    </div>
                  )
                }
                scrollableTarget="scroll-target"
              >
                {affiliateUsers?.length ? (
                  affiliateUsers?.map((user) => {
                    return (
                      <div className="card_list" key={user.email}>
                        <Row gutter={10} align="middle">
                          <Col>
                            <Avatar shape="square" size={42} src={profile} />
                          </Col>
                          <Col lg={10}>
                            <h4>{user?.email}</h4>

                            {/* {<p className="mt-1">{user.email}</p>} */}
                          </Col>
                          <Col lg={12} style={{ textAlign: "right" }}>
                            <p>
                              {formatToLocalTime(user?.createdAt)}
                              {"         "}
                              {!user?.isPasswordSet ? (
                                <Tooltip
                                  title="Login Required"
                                  placement="bottom"
                                >
                                  <span>
                                    <img src={circle} alt="circle" width={20} />
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Completed" placement="bottom">
                                  <span>
                                    <img src={active} alt="circle" width={20} />
                                  </span>
                                </Tooltip>
                              )}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center pt-5">No data found!</div>
                )}
              </InfiniteScroll>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
}
